<template>
  <div
    class="d-flex"
    style="gap: 40px;">
    <div>
      <div class="fs-m font-weight-bold mb-2">
        ノート記録日数
      </div>
      <div
        class="d-flex align-items-center">
        <div
          class="bg-grey03 text-center p-1 mr-1"
          style="width: 60px;">
          {{ recordDays }}
        </div>
        日
      </div>
    </div>
    <div>
      <div class="fs-m font-weight-bold mb-2">
        自己評価月数
      </div>
      <div
        class="d-flex align-items-center">
        <div
          class="bg-grey03 text-center p-1 mr-1"
          style="width: 60px;">
          {{ evaluationMonths }}
        </div>
        ヶ月
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActivitiesSection',
  props: {
    userId: {
      type: String,
      required: true,
    },
    recordDays: {
      type: Number,
      required: true,
    },
    evaluationMonths: {
      type: Number,
      required: true,
    }
  },
}
</script>

<style>

</style>